<template>
  <div class="uk-container">
    <img
      class="logo"
      src="../../common/assets/logo.png"
    />

    <h1 class="mb-5">Ticket #{{ project.id }} Additional Info Form</h1>
    <p class="uk-text-muted uk-margin-remove-bottom">{{ project.name }}</p>
    <p class="uk-margin-large-bottom"></p>

    <div v-if="error" class="uk-alert-danger" uk-alert>
      {{ error }}
    </div>

    <template v-if="done">
      <p>Thank you for your feedback.</p>
    </template>

    <template v-else>
      <ui-form
        ref="form"
        :model="model"
        :rules="validationRules"
      >
        <ui-form-item
          label="Your Name"
          prop="name"
          required>
          <ui-form-input v-model="model.name" name="name" />
        </ui-form-item>

        <ui-form-item
          label="Additional Info"
          prop="comments"
          required>
          <ui-form-input v-model="model.comments" name="comments" type="textarea" rows="10" />
        </ui-form-item>

        <button
          type="submit"
          class="uk-button uk-button-primary uk-margin-right"
          @click.prevent="submit"
          :disabled="submitting"
        >
          <span v-if="submitting" uk-spinner></span>
          <span v-else>Submit</span>
        </button>
      </ui-form>
    </template>

    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
  </div>
</template>

<script>
import axios from 'axios'
import { serverUrl } from '../../common/helper/serverUrl'
import UiFormPartial from '../components/Form/FormPartial'

export default {
  components: { UiFormPartial },

  props: {
    user: {
      type: String,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      done: false,

      error: null,

      model: {
        name: this.user,
        comments: '',
      },

      submitting: false,
    }
  },

  computed: {
    validationRules() {
      return {
        name: ['required'],
        comments: ['required'],
      }
    },

    submitUrl() {
      return serverUrl('/promotion-change-form/handle')
    },
  },

  methods: {
    $_validation_validate() {
      return new Promise((resolve, reject) => {
        if (!('form' in this.$refs)) {
          resolve()
          return
        }

        this.$refs.form.validate()
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    async submit() {
      this.$_validation_validate()
        .then(() => {
          this.submitting = true
          this.error = null

          const showError = (message) => {
            this.error = message
            window.scrollTo(0, 0)
          }

          axios
            .post(this.submitUrl, {
              data: this.model,
            }, {
              params: {
                id: this.project.id,
                token: this.project.token,
              },
            })
            .then(_ => {
              this.done = true
              this.error = null
            })
            .catch(error => {
              if ('detail' in error.response.data) {
                showError(error.response.data.detail)
                Promise.resolve(error)
              }
            })
            .then(() => {
              this.submitting = false
            })
        })
        .catch(() => {
          this.$refs.form.focusOnFirstError()
        })
    },
  },

}
</script>

<style lang="scss" src="../scss/app.scss">
</style>
